var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-dropzone',{ref:"dropzone",staticClass:"obi-file-upload",attrs:{"id":_vm.id,"options":_vm.dropzoneOptions}},[_c('ObiText',{staticClass:"d-flex justify-content-center flex-column"},[_c('ObiIcon',{staticClass:"mb-3",attrs:{"icon":_vm.IconUpload}}),_c('ObiText',{domProps:{"innerHTML":_vm._s(_vm.errorMessage || _vm.$t('message'))}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }